import { Links } from './linkBuilder';

const deepClone = (obj) => JSON.parse(JSON.stringify(obj));

export const resolveLinks = (sidebar, shopId) => {
  const newSidebar = deepClone(sidebar);
  Object.values(newSidebar).forEach((section) => {
    section.children.forEach((child) => {
      if (child.linkKey) child.link = Links[child.linkKey](shopId);
      if (child.type === 'collapse') {
        child.children.forEach((subChild) => {
          if (subChild.linkKey) subChild.link = Links[subChild.linkKey](shopId);
        });
      }
    });
  });
  return newSidebar;
};
